// tslint:disable: max-classes-per-file

export interface ILevelResponse {
  sequence: number;
  ask_order_number: number;
  ask: number;
  ask_size: number;
  bid_order_number: number;
  bid: number;
  bid_size: number;
}

export interface ILevelOldResponse {
  sequence: number;
  buyNumOrders: number;
  buyPrice: number;
  buyVolume: number;
  sellNumOrders: number;
  sellPrice: number;
  sellVolume: number;
}

export interface ILevelWebsocketResponse {
  BuyOrdersNum: number;
  BuyPrice: number;
  BuyVolume: number;
  SellOrdersNum: number;
  SellPrice: number;
  SellVolume: number;
}

export interface ILevel {
  sequence: number;
  askOrderNumber: number;
  ask: number;
  askSize: number;
  bidOrderNumber: number;
  bid: number;
  bidSize: number;
}

export class LevelViewModel implements ILevel {
  static fromJSON(json: ILevelResponse): LevelViewModel {
    return new LevelViewModel(
      json.sequence,
      json.ask_order_number,
      json.ask,
      json.ask_size,
      json.bid_order_number,
      json.bid,
      json.bid_size,
    );
  }

  static fromJSONOld(json: ILevelOldResponse): LevelViewModel {
    return new LevelViewModel(
      json.sequence,
      json.buyNumOrders,
      json.buyPrice,
      json.buyVolume,
      json.sellNumOrders,
      json.sellPrice,
      json.sellVolume,
    );
  }

  static fromWebsocket(json: ILevelWebsocketResponse): LevelViewModel {
    return new LevelViewModel(
      0,
      json.BuyOrdersNum,
      json.BuyPrice,
      json.BuyVolume,
      json.SellOrdersNum,
      json.SellPrice,
      json.SellVolume,
    );
  }

  toJSON(): ILevelResponse {
    return Object.assign(
      {},
      {
        sequence: this.sequence,
        ask_order_number: this.askOrderNumber,
        ask: this.ask,
        ask_size: this.askSize,
        bid_order_number: this.bidOrderNumber,
        bid: this.bid,
        bid_size: this.bidSize,
      },
    );
  }

  constructor(
    public sequence: number,
    public askOrderNumber: number,
    public ask: number,
    public askSize: number,
    public bidOrderNumber: number,
    public bid: number,
    public bidSize: number,
  ) {}
}
